// import { useEffect, useState, useRef } from 'react'
// import axios from 'axios'
// import Cookies from 'js-cookie'
// import { useAuth } from '../Providers/AuthProvider';
// import { useConfig } from '../Providers/ConfigProvider';
// import { GetProductsFeaturesWithQuery } from '../Services/ProductService';


// var qs = require('qs');

// export default function useLoadingProducts(pageNumber, setPageNumber, productsFilter, setProductsFilter, activeCategory, setActiveCategory) {

//   const headers = {
//     'Content-Type': 'application/json',
//     'Authorization': "Bearer" + " " + localStorage.getItem('token'),
//     'currentContractorId': Cookies.get('currentContractorId')
//   }

//   const { authState } = useAuth()
//   const { api } = useConfig()

//   const [loadingProducts, setLoadingProducts] = useState(true)
//   const [error, setError] = useState(false)
//   const [products, setProducts] = useState([])
//   const [productsFeatures, setProductFeatures] = useState([])
//   const [hasMore, setHasMore] = useState(false)
//   const isFetchingRef = useRef(false)

//   useEffect(() => {
//     if (activeCategory)
//       if (activeCategory.catLevel < 3 && (!productsFilter.SearchingQuery || productsFilter.SearchingQuery.trim() === '')) {
//         setProductFeatures([])
//       }
//   }, [activeCategory])

//   useEffect(() => {
//     if ((!productsFilter.SearchingQuery || productsFilter.SearchingQuery.trim() === '')) { // musimy jeszcze na zdjęciu querry usunąc featery jeżeli catLevel < 3
//       if (!activeCategory || (activeCategory && activeCategory.catLevel < 3)) {
//         setProductFeatures([])
//       }
//     }
//   }, [productsFilter.SearchingQuery])

//   useEffect(() => {
//     if ((productsFilter.SearchingQuery && productsFilter.SearchingQuery.trim() !== '') || (activeCategory && activeCategory.catLevel >= 3)) {
//       handleGetProductFeatureWithQuery(productsFilter)
//     }
//   }, [productsFilter])

//   useEffect(() => {
//     if (pageNumber !== 0) { // w przeciwnym wypadku na pewno mamy pobrane dane innym trigerrem, nie chcemy pobierac po kilka razy
//       handleGetProducts(true)
//     }
//   }, [pageNumber])

//   useEffect(() => {
//     handleGetProducts(false)
//   }, [authState, productsFilter])
//   useEffect(() => {
//     if (!productsFilter.SearchingQuery) {
//       handleGetProducts(false)
//     }
//   }, [productsFilter.SearchingQuery])

//   useEffect(() => {
//     handleGetProductsFeature()
//   }, [activeCategory])


//   const handleGetProductsFromSearchingBar = async (queryParam, allArticles) => {
//     if (!queryParam || queryParam.trim() === '') {
//       return
//     }

//     isFetchingRef.current = true
//     setLoadingProducts(true)
//     setProductsFilter(prev => ({
//       ...prev,
//       ProductsFeatures: [],
//       ActiveCatNodeId: 0,
//       ArtCatOrSymbolList: [],
//       ArtNo: "0",
//       SearchingQuery: queryParam,
//       AllArticles: allArticles ? allArticles : productsFilter.IsSellOut
//     }))
//     setPageNumber(0)
//     setProducts([])
//     setActiveCategory(0)
//     localStorage.setItem("categoryNavigationTree", JSON.stringify(null))
//     //setDownloadCategoriesAfterQuerySearching(true)

//     let tmpProductFilters = {
//       ProductsFeatures: [],
//       AvailabilityFilters: {
//         OnlyLocal: productsFilter.AvailabilityFilters.OnlyLocal,
//         OnlyRegional: productsFilter.AvailabilityFilters.OnlyRegional,
//         OnlyMacroRegional: productsFilter.AvailabilityFilters.OnlyMacroRegional,
//       },
//       IsNew: productsFilter.IsNew,
//       IsPromo: productsFilter.IsPromo,
//       IsSellOut: productsFilter.IsSellOut,
//       PriceFrom: productsFilter.PriceFrom,
//       PriceTo: productsFilter.PriceTo,
//       ActiveCatNodeId: 0,
//       ArtCatOrSymbolList: [],
//       ArtNo: "0",
//       CustId: authState.custId,
//       SearchingQuery: queryParam,
//       SiteId: authState.siteId ? authState.siteId : '',
//       WhId: authState.whId ? authState.whId : '',
//       AllArticles: allArticles ? allArticles : productsFilter.IsSellOut,
//       SupplierIds: productsFilter.SupplierIds,
//     }

//     await api.post(`/api/v1/Product`,
//       tmpProductFilters,
//       {
//         headers: headers,
//         params: {
//           pageNumber: 0,
//           sortBy: productsFilter.SortType,
//         },
//         paramsSerializer: params => {
//           return qs.stringify(params);
//         },
//       }
//     )
//       .then(res => {
//         setProducts(prevProducts => [...prevProducts, ...res.data])
//         setHasMore(res.data.length > 0)
//         setLoadingProducts(false)
//       })
//       .catch(e => {
//         console.log(e)
//       })
//       .finally(() => {
//         isFetchingRef.current = false
//       })
//     await handleGetProductFeatureWithQuery(tmpProductFilters)
//   }

//   const handleGetProducts = async (keepData) => {
//     if (isFetchingRef.current) {
//       //return
//     }
//     isFetchingRef.current = true
//     const tmpPageNo = keepData ? pageNumber : 0
//     if (!keepData) {
//       setPageNumber(0)
//       setProducts([])
//     }
//     setLoadingProducts(true)
//     setError(false)
//     let cancel
//     await api.post(
//       `/api/v1/Product`,
//       productsFilter,
//       {
//         headers: headers,
//         params: {
//           pageNumber: tmpPageNo,
//           sortBy: productsFilter.SortType,
//         },
//         paramsSerializer: params => {
//           return qs.stringify(params);
//         },
//         cancelToken: new axios.CancelToken(c => (cancel = c)),
//       }
//     )
//       .then(res => {
//         setProducts(prevProducts => [...prevProducts, ...res.data]);
//         setHasMore(res.data.length > 0);
//         setLoadingProducts(false)
//       })
//       .catch(e => {
//         if (axios.isCancel(e)) {
//           setLoadingProducts(false)
//           return
//         }
//         console.error(e)
//       })
//       .finally(() => {
//         isFetchingRef.current = false
//       })

//     return () => cancel();
//   }

//   const handleGetProductsFeature = async () => {
//     if (!activeCategory) {
//       return
//     }
//     if (activeCategory) {
//       if (activeCategory.catLevel < 3) {
//         return
//       }
//     }
//     if (productsFilter.ActiveCatNodeId === 0 && (!productsFilter.SearchingQuery || productsFilter.SearchingQuery.trim() !== '')) {
//       return
//     }
//     try {
//       const res = await GetProductsFeaturesWithQuery(api, productsFilter)
//       setProductFeatures(res.data)
//     } catch (error) {
//       console.log(error)
//       setProductFeatures([])
//     }
//   }

//   const handleGetProductFeatureWithQuery = async (productsFilterParam) => {
//     try {
//       const res = await GetProductsFeaturesWithQuery(api, productsFilterParam)
//       setProductFeatures(res.data)
//     } catch (error) {
//       console.log(error)
//       setProductFeatures([])
//     }
//   }

//   return { loadingProducts, error, products, hasMore, productsFeatures, handleGetProductsFromSearchingBar, setProducts }
// }


// useLoadingProducts.js

import { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useAuth } from '../Providers/AuthProvider';
import { useConfig } from '../Providers/ConfigProvider';
import { GetProductsFeaturesWithQuery } from '../Services/ProductService';
import useDebounce from '../Hooks/useDebounce';

var qs = require('qs');


export default function useLoadingProducts(pageNumber, setPageNumber, productsFilter, setProductsFilter, activeCategory, setActiveCategory) {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': "Bearer" + " " + localStorage.getItem('token'),
    'currentContractorId': Cookies.get('currentContractorId')
  }

  const { useDebounceWithStrongValueCheck } = useDebounce()
  const { authState } = useAuth()
  const { api } = useConfig()

  const [loadingProducts, setLoadingProducts] = useState(true)
  const [error, setError] = useState(false)
  const [products, setProducts] = useState([])
  const [productsFeatures, setProductFeatures] = useState([])
  const [hasMore, setHasMore] = useState(false)

  //Tworzymy "opóźnioną" wersję naszego obiektu filtra
  const debouncedFilter = useDebounceWithStrongValueCheck(productsFilter, 300)

  useEffect(() => {
    setProducts([])
    setPageNumber(0)
  }, [JSON.stringify(debouncedFilter), authState.custId])

  useEffect(() => {
    // if ((!debouncedFilter.SearchingQuery || debouncedFilter.SearchingQuery.trim() === '') && (!activeCategory || activeCategory.catLevel < 3)) {
    //   setProductFeatures([])
    //   return
    // }
    if ((!debouncedFilter.SearchingQuery || debouncedFilter.SearchingQuery.trim() === '') && (!activeCategory || activeCategory.catLevel < 3) && (!productsFilter.ProductsFeatures || productsFilter.ProductsFeatures.length === 0)) {
      setProductFeatures([])
      return
    }

    const source = axios.CancelToken.source()
    GetProductsFeaturesWithQuery(api, debouncedFilter, source.token)
      .then(res => {
        setProductFeatures(res.data)
      })
      .catch(err => {
        if (!axios.isCancel(err)) {
          console.log(err)
          setProductFeatures([])
        }
      })

    return () => source.cancel()
  }, [JSON.stringify(debouncedFilter)])//DK : activeCategory tej on jest w filtrze! bez sensu go tu używać?


  // Główny efekt do pobierania produktów używa opóźnionego filtra
  useEffect(() => {
    setLoadingProducts(true)
    setError(false)

    const source = axios.CancelToken.source()

    api.post('/api/v1/Product', debouncedFilter, { // Używamy `debouncedFilter`
      headers: headers,
      params: {
        pageNumber: pageNumber,
        sortBy: debouncedFilter.SortType,
      },
      paramsSerializer: params => qs.stringify(params),
      cancelToken: source.token
    })
      .then(res => {
        setProducts(prevProducts => {
          return pageNumber === 0 ? res.data : [...prevProducts, ...res.data]
        });
        setHasMore(res.data.length > 0)
      })
      .catch(e => {
        if (axios.isCancel(e)) {
          return
        }
        setError(true)
        console.error(e)
      })
      .finally(() => {
        setLoadingProducts(false)
      })

    return () => {
      source.cancel()
    }

  }, [JSON.stringify(debouncedFilter), pageNumber, authState.custId])


  const handleGetProductsFromSearchingBar = (queryParam, allArticles) => {
    if (!queryParam || queryParam.trim() === '') {
      return
    }

    setPageNumber(0)
    // setActiveCategory(null)
    // localStorage.setItem("categoryNavigationTree", JSON.stringify(null))    

    setProductsFilter(prev => ({
      ...prev,
      //ProductsFeatures: [],
      //ActiveCatNodeId: 0,
      //ArtCatOrSymbolList: [],
      SearchingQuery: queryParam,
      //AllArticles: allArticles ? allArticles : false
    }))
  }

  return { loadingProducts, error, products, hasMore, productsFeatures, handleGetProductsFromSearchingBar, setProducts }
}
